module.exports = __webpack_public_path__ + "img/anne_christians.14360235.jpg";